import React, {Component} from 'react';

class NotFound extends Component {
    render() {
        return (
            <div>
                Pagina non trovata
            </div>
        );
    }
}

export default NotFound;